import { Country, type StenaPermissions } from '@sr/types';
import { findCountryFromDwKey, isConfidential, isFromCountry } from '../country';

export const getCountry = (dwKey: string): Country => {
  if (isConfidential(dwKey)) {
    return Country.CONFIDENTIAL;
  }

  const country = findCountryFromDwKey(dwKey);

  if (!country) {
    throw Error(`dwKey ${dwKey} is not supported`);
  }

  return country;
};

export const hasSwedishPartners = (permissions: StenaPermissions | null | undefined) => {
  return hasPartnerWithCountryId(permissions, Country.SWEDEN);
};

export const hasNorwegianPartners = (permissions: StenaPermissions | null | undefined) => {
  return hasPartnerWithCountryId(permissions, Country.NORWAY);
};

export const hasDanishPartners = (permissions: StenaPermissions | null | undefined) => {
  return hasPartnerWithCountryId(permissions, Country.DENMARK);
};

export const selectedPartnerIsCountry = (partners: string[], country: Country): boolean =>
  partners.some((partner) => isFromCountry(partner, country));

const hasPartnerWithCountryId = (
  permissions: StenaPermissions | null | undefined,
  country: Country,
) => {
  if (!permissions) return false;
  const { businessPartners } = permissions;

  return businessPartners.some((partner) => isFromCountry(partner.id, country));
};
